import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { LOGO_FULL } from "../../lib/content";

const links = [
  { label: "Platform", href: "#platform" },
  { label: "Card & P2P", href: "#card" },
  { label: "How it works", href: "#how" },
  { label: "Security", href: "#security" },
  { label: "Pricing", href: "#pricing" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-shadow duration-300 ${scrolled ? "shadow-[0_4px_24px_rgba(10,12,20,0.06)]" : ""}`}
    >
      <div className="border-b border-slate-200/50 bg-white/70 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
          <a href="#top" data-testid="nav-logo" className="flex items-center">
            <img src={LOGO_FULL} alt="Nomoex Pay" className="h-7 w-auto" />
            <span className="ml-2 hidden rounded-full bg-[#E8EDFF] px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.15em] text-[#3B5FE8] sm:inline">Pay</span>
          </a>
          <nav className="hidden items-center gap-8 lg:flex">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="text-sm font-medium text-slate-600 transition-colors duration-200 hover:text-[#3B5FE8]"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <a href="#waitlist" data-testid="nav-waitlist-cta" className="btn-primary px-5 py-2 text-xs font-semibold sm:px-6 sm:py-2.5 sm:text-sm">
            Join waitlist
          </a>
        </div>
      </div>
    </motion.header>
  );
};
